import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { Reveal } from './Reveal';
export function Bonuses() {
  return <section className="border-t border-paper-line bg-paper px-5 py-20 sm:py-28 lg:px-8" aria-labelledby="bonos" data-id="element-19" data-mp="pm29dppob3dv">
      <div className="mx-auto max-w-6xl" data-id="element-20" data-mp="ftwikjb5qs09">
        <Reveal data-id="element-21" data-mp="fslgqp19vubs">
          <p className="flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-22" data-mp="fs3dh8g70fud">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-23" data-mp="5w0c44t60l8h" />
            Si comprás hoy
          </p>
          <h2 id="bonos" className="display mt-4 max-w-3xl text-4xl text-ink sm:text-5xl lg:text-6xl" data-id="element-24" data-mp="3o1lferpctljg">
            Te regalo 5 herramientas de oro
          </h2>
        </Reveal>

        <ol className="mt-14 divide-y divide-paper-line border-y border-paper-line" data-id="element-25" data-mp="1mai4s2fgs6yw">
          {bonuses.map((bonus, i) => <Reveal key={bonus.name} delay={i * 0.03} data-id="element-26" data-mp="1r8a5nly373f8" data-mpi={i}>
              <li className="flex flex-col gap-2 py-6 sm:flex-row sm:items-baseline sm:gap-8" data-id="element-27" data-mp="3ieg752qpk50b">
                <span className="display w-14 shrink-0 text-2xl text-ink/20" data-id="element-28" data-mp="3dfd2hjen40sv">
                  0{i + 1}
                </span>
                <div className="flex-1" data-id="element-29" data-mp="3r6zz5kchvbc6">
                  <h3 className="text-lg font-bold uppercase tracking-tight text-ink" data-id="element-30" data-mp="3r5ymxcjqsisv">
                    {bonus.name}
                  </h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-ink-soft" data-id="element-31" data-mp="2zfals0i2jdf7">
                    {bonus.body}
                  </p>
                </div>
                <p className="shrink-0 text-sm font-bold sm:w-28 sm:text-right" data-id="element-32" data-mp="2uibtzolvnik6">
                  <span className="text-ink-dim line-through" data-id="element-33" data-mp="38htp0lprns1z">{bonus.value}</span>{' '}
                  <span className="text-grass" data-id="element-34" data-mp="33g4er8adbiey">gratis</span>
                </p>
              </li>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}